// extracted by mini-css-extract-plugin
module.exports = {"actions":"wage-actions_actions__3RXRs"};